import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { Switch, useLocation } from "react-router-dom";

import { LeadDetail } from "screens/leadDetail";
import Estatisticas from "screens/estatisticas";
import MesaTelefone from "screens/mesaTelefone";
import { OportunidadesDetail } from "screens/oportunidadesDetail";
import { SimuladorRepasseChaves } from "screens/simuladorRepasseChaves";
import { SimuladorRepasseAssociativo } from "screens/simuladorRepasseAssociativo";
import FunilPropostas from "screens/funilPropostas";
import FunilComercial from "screens/funilComercial";
import { PerfilAutonomo } from "screens/perfilAutonomo";
import Roleta from "screens/roleta";
import { CARGO_CODES } from "constants/permissions";
import { Campanhas, CampanhasDetail, CreateCampanhas } from "screens/campanhas";
import PropostaVendasPage from "screens/oportunidadesDetail/components/propostaCard/components/PropostaVendasModal";
import Carometro from "screens/carometro";
import Destaques from "screens/destaques";
import HomeNew from "screens/homeNew";
import { Revenda } from "screens/revenda";
import { Visitas } from "screens/visitas";
import ControleVisitas from "../screens/controleVisitas";
import NavBar from "../components/sideBarCommon";
import Login from "../screens/auth";
import ConfirmShare from "../screens/confirmShare";
import DashBoard from "../screens/home";
import { Leads } from "../screens/leads";
import NewLead from "../screens/newLead";
import Plantao from "../screens/plantao";
import ProductDetail from "../screens/producsDetail";
import Products from "../screens/products";
import StandEspelho from "../screens/standEspelho";
import SharedLead from "../screens/sharedLead";
import { AuthState } from "../store/ducks/auth/types";
import Route from "./router";
import Academia from "../screens/academia";
import BlockSellit from "../screens/block";
import Checkin from "../screens/checkin";
import RoletaAoVivo from "../screens/roletaAoVivo";
import TermosDeUso from "../screens/TermosDeUso";
import MobileRedirect from "../screens/mobileRedirect";
import Calendario from "../screens/calendario";
import DeepLinkRedirect from "../screens/deepLinkRedirect";
import WhatsApp from "../screens/whatsapp";
import CadastroCyrela from "../screens/cadastroCyrela";

function Routes() {
  // Pegar dados diretamente do Redux (não ler localStorage manualmente)
  const {
    signed,
    usuarioComercial,
    usuarioBackofficeVivaz,
    permissoes,
    usuarioCia,
    codigoCargo2013,
    supervisorProduto,
    possuiToken3cplus,
  } = useSelector<RootStateOrAny, AuthState>((state) => state.user);

  const permissionsObject: string[] = permissoes || [];

  const possuiToken3cplusValid: boolean = possuiToken3cplus ?? false;

  const location = useLocation();
  const isTermosDeUso = location.pathname === "/termos-de-uso";
  const isDeepLink = location.pathname === "/deeplink";
  const navBarAppears = signed && !isTermosDeUso && !isDeepLink;

  // Configuração de permissões por rota
  const permissions = {
    menu: codigoCargo2013 !== CARGO_CODES.RECEPCIONISTA,
    plantao:
      codigoCargo2013 === CARGO_CODES.RECEPCIONISTA ||
      codigoCargo2013 === CARGO_CODES.SUPERVISOR,
    roleta:
      codigoCargo2013 === CARGO_CODES.RECEPCIONISTA ||
      codigoCargo2013 === CARGO_CODES.SUPERVISOR ||
      codigoCargo2013 === CARGO_CODES.CORRETOR,
    leads:
      codigoCargo2013 !== CARGO_CODES.RECEPCIONISTA &&
      codigoCargo2013 !== CARGO_CODES.SUPERVISOR &&
      codigoCargo2013 !== CARGO_CODES.COORDENADOR_PRODUTO,
  };

  const canAccessFunilPropostas = permissions.menu || usuarioBackofficeVivaz;
  const canAccessOportunidadeDetail =
    permissions.menu || usuarioBackofficeVivaz;

  if (isDeepLink) {
    return <DeepLinkRedirect />;
  }

  return (
    <>
      {navBarAppears && <NavBar />}
      <div className={`app-content ${!navBarAppears ? "no-sidebar" : ""}`}>
        <Switch>
          <Route
            path="/"
            allowedRoute
            exact
            isPrivate={false}
            component={Login}
          />
          <Route
            path="/termos-de-uso"
            allowedRoute
            exact
            isPrivate={false}
            component={TermosDeUso}
          />
          <Route
            path="/deeplink"
            allowedRoute
            exact
            isPrivate={false}
            component={DeepLinkRedirect}
          />
          <Route
            path="/block"
            allowedRoute
            exact
            isPrivate
            component={BlockSellit}
          />
          <Route
            path="/menu"
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={HomeNew}
          />
          <Route
            path="/leads"
            exact
            allowedRoute={permissions.leads}
            allowedRouteRedirect={"/plantao"}
            isPrivate
            component={Leads}
          />
          <Route
            path="/leads-infos"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={DashBoard}
          />
          <Route
            path="/leads/:idLeadCorretor"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={LeadDetail}
          />
          <Route
            path="/lead-detail/:idLeadCorretor"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={LeadDetail}
          />
          <Route
            path="/leads-novo"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={NewLead}
          />
          <Route
            path="/leads-compartilhados"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={SharedLead}
          />
          <Route
            path="/transferencia-concluida/:action"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={ConfirmShare}
          />
          <Route
            path="/produtos"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={Products}
          />
          <Route
            path="/produtos/:idEmpreendimento"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={ProductDetail}
          />
          <Route
            path="/stand-espelho"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={StandEspelho}
          />
          <Route
            path="/lead-detail/:idLeadCorretor/proposition-detail/:numeroCotacao"
            exact
            allowedRoute={canAccessOportunidadeDetail}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={OportunidadesDetail}
          />
          <Route
            path="/lead-detail/:idLeadCorretor/:idLead/proposition-detail/:numeroCotacao/:idOportunidade"
            exact
            allowedRoute={canAccessOportunidadeDetail}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={PropostaVendasPage}
          />

          <Route
            path="/lead-detail/:idLeadCorretor/repasse-associativo/:idUnidade/:idOportunidade?/:numeroCotacao?/:action?"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={SimuladorRepasseAssociativo}
          />
          <Route
            path="/lead-detail/:idLeadCorretor/:idLead/repasse-chaves/:idUnidade/:idOportunidade?/:numeroCotacao?/:action?"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={SimuladorRepasseChaves}
          />
          <Route
            path="/academia"
            exact
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={Academia}
          />
          <Route
            path="/plantao"
            exact
            isPrivate
            allowedRoute={permissions.plantao}
            allowedRouteRedirect="/menu"
            component={Plantao}
          />
          <Route
            path="/roleta"
            exact
            isPrivate
            allowedRoute={permissions.roleta}
            allowedRouteRedirect="/menu"
            component={Roleta}
          />
          {/* <Route
          path="/estatisticas"
          allowedRoute={!permissionsObject.includes("tela_atendimento_visita")}
          allowedRouteRedirect="/plantao"
          isPrivate
          component={Estatisticas}
        /> */}
          <Route
            path="/destaques"
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/menu"
            isPrivate
            component={Destaques}
          />
          <Route
            path="/funil-de-propostas"
            allowedRoute={canAccessFunilPropostas}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={FunilPropostas}
          />
          <Route
            path="/funil-comercial"
            allowedRoute={permissions.menu && usuarioComercial === true}
            allowedRouteRedirect="/plantao"
            isPrivate
            component={FunilComercial}
          />
          <Route
            path="/mesa-telefone"
            exact
            isPrivate
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            component={MesaTelefone}
          />
          <Route
            path="/perfil"
            isPrivate
            allowedRoute
            component={PerfilAutonomo}
          />
          <Route
            path="/revenda"
            isPrivate
            allowedRoute={permissionsObject.includes("conexao_revenda")}
            component={Revenda}
          />
          <Route path="/checkin" isPrivate allowedRoute component={Checkin} />
          <Route
            path="/roleta-ao-vivo/:id"
            isPrivate
            allowedRoute
            component={RoletaAoVivo}
          />
          <Route
            path="/carometro"
            isPrivate
            allowedRoute
            component={Carometro}
          />
          <Route
            path="/campanhas-criadas"
            exact
            isPrivate
            allowedRoute={
              !permissionsObject.includes("tela_atendimento_visita") &&
              possuiToken3cplusValid
            }
            allowedRouteRedirect="/plantao"
            component={Campanhas}
          />
          <Route
            path="/criar-campanha"
            exact
            isPrivate
            allowedRoute={
              !permissionsObject.includes("tela_atendimento_visita") &&
              possuiToken3cplusValid
            }
            allowedRouteRedirect="/plantao"
            component={CreateCampanhas}
          />
          <Route
            path="/campanha/:id"
            exact
            isPrivate
            allowedRoute={
              !permissionsObject.includes("tela_atendimento_visita") &&
              possuiToken3cplusValid
            }
            allowedRouteRedirect="/plantao"
            component={CampanhasDetail}
          />
          <Route path="/visitas" isPrivate allowedRoute component={Visitas} />
          <Route
            path="/controle-visitas"
            isPrivate
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            component={ControleVisitas}
          />
          <Route
            path="/calendario"
            isPrivate
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            component={Calendario}
          />
          <Route
            path="/controle-visitas"
            isPrivate
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            component={ControleVisitas}
          />
          <Route
            path="/whatsapp/:leadId?"
            isPrivate
            allowedRoute={permissions.menu}
            allowedRouteRedirect="/plantao"
            component={WhatsApp}
          />
          <Route
            path="/cadastro-cyrela"
            exact
            isPrivate
            allowedRoute
            component={CadastroCyrela}
          />
        </Switch>
      </div>
    </>
  );
}

export { Routes as AppRoutes };

export default function Router() {
  return <Routes />;
}
